import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';

@Component({
    selector: 'app-common-feature-item',
    templateUrl: './common-feature-item.component.html',
    styleUrls: ['./common-feature-item.component.css'],
    standalone: false
})
export class CommonFeatureItemComponent {
    @Input()
    public commonFeature: CommonFeatureInterface;

    @Output()
    public updatedFeature = new EventEmitter<CommonFeatureInterface>();

    @Output()
    public deletedFeature = new EventEmitter<CommonFeatureInterface>();

    public showFeatureEntries: boolean = false;
    public showEditFeature: boolean = false;

    constructor(
        private commonFeatureService: CommonFeatureService,
        private dialogService: DialogService
    ) {}

    /* Toggles whether the Entries of a Feature are shown or not */
    public toggleFeatureEntries(): void {
        this.showFeatureEntries = !this.showFeatureEntries;
    }

    /* Enables the Frontend Edit Mode in which the Values are shown in Input Fields */
    public editFeature(): void {
        this.showEditFeature = true;
        this.showFeatureEntries = false;
    }

    /* Calls the Service to update the Feature with the Form Values */
    private saveFeature(): void {
        //const featureElements = this.child.getElements();
        this.commonFeatureService
            .updateFeature(this.commonFeature)
            .subscribe((success) => {
                this.updatedFeature.emit(success);
            });
    }

    /* Calls the Service to delete the Feature */
    private deleteFeature(): void {
        this.dialogService
            .openConfirmDialog(
                'Löschen eines Common Features',
                'Nein',
                'Ja',
                'Sind sie sich sicher das sie ' +
                    this.commonFeature.name +
                    ' löschen wollen?'
            )
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.commonFeatureService
                        .deleteFeature(this.commonFeature.id)
                        .subscribe(() => {
                            this.deletedFeature.emit(this.commonFeature);
                        });
                }
            });
    }

    onCloseEdit(result: 'ABORT' | 'SAVE' | 'DELETE'): void {
        switch (result) {
            case 'SAVE': {
                this.saveFeature();
                break;
            }
            case 'DELETE': {
                this.deleteFeature();
                break;
            }
        }
        this.showEditFeature = false;
    }
}
